import { render, staticRenderFns } from "./BatchCard.vue?vue&type=template&id=6c37e456&"
import script from "./BatchCard.vue?vue&type=script&lang=js&"
export * from "./BatchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports